export default "/static/dashboard/build/app/img/v2/422fe292b30c1664d0af04260af7cda2.png";